import { PayloadAction } from '@reduxjs/toolkit';
import { IModalInitial } from './types';

export const actions = {
  showModal(state: IModalInitial, { payload }: PayloadAction<string>) {
    state.isOpen = true;
    state.tag = payload;
  },
  closeModal(state: IModalInitial) {
    state.isOpen = false;
    state.tag = '';
  },
};
